import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  label {
    color: #000;
    font-family: Montserrat;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;

    ${({ marginBottom }) => marginBottom && "margin-bottom: 16px;"}
  }

  ${({ height }) => (height ? height : "height: 78px;")}

  input {
    border: 1px solid #96989a;
    padding: 8px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    &:disabled {
      background-color: #96989a;
      border: 1px solid #96989a;
    }
  }

  p {
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
    margin: 0;
  }

  span {
    color: #ff0000;
  }
`;
